import { useTranslation } from 'react-i18next';

import { DataPanelInlineItem } from '@/ui';
import { DateFormatter } from '@/features/shared/DateFormatter';

export type DateTimeInfoPanelProps = {
  createdTimeUtc: string;
  closedTimeUtc: string | null;
  incidentIsReadOnly: boolean;
};

export function DateTimeInfoPanel({ createdTimeUtc, closedTimeUtc, incidentIsReadOnly }: DateTimeInfoPanelProps) {
  const { t } = useTranslation();
  const incidentIsClosed = closedTimeUtc != null;

  return (
    <>
      <DataPanelInlineItem title={t('Incident_InfoPanel_CreatedTime')}>
        <DateFormatter
          date={createdTimeUtc}
          updateIntervalMs={1000}
          formatType={incidentIsReadOnly ? 'calendar' : 'combined'}
        />
      </DataPanelInlineItem>

      {incidentIsClosed && (
        <DataPanelInlineItem title={t('Incident_InfoPanel_ClosingTime')}>
          <DateFormatter
            date={closedTimeUtc}
            updateIntervalMs={1000}
            formatType={incidentIsReadOnly ? 'calendar' : 'combined'}
          />
        </DataPanelInlineItem>
      )}
    </>
  );
}
